/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Select,
  Table,
  AutoComplete,
  Input,
  Spin,
  Badge,
} from "antd";
import "./index.css";
import { DownloadOutlined } from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import {
  loadBillStatusMetaData,
  loadPurchaseSummaryReport,
} from "../../store/reports/actions";
import DatePicker from "react-datepicker";
import api from "../../helpers";
import { loadVendor } from "../../store/vendor/actions";

const PurchaseSummaryReport = (props) => {
  const dispatch = useDispatch();

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  const media = useMedia();

  const stockGetPayload = {
    organizationId: organizationId,
    page: 1,
    limit: 10,
  };

  //initial state values
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [billStatusList, setBillStatusList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadPurchaseSummaryReport(stockGetPayload));
    dispatch(loadBillStatusMetaData());
    dispatch(
      loadVendor({
        organizationId: organizationId,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { purchase_summary_report = {}, billStatusMetaData = {} } = useSelector(
    (state) => state.Reports
  );
  const { vendor_list = {} } = useSelector((state) => state.Vendor);

  const partyOptions =
    vendor_list && vendor_list.length > 0
      ? vendor_list.map((data) => {
          return { value: data._id, label: data.vendorName };
        })
      : [];

  //header columns
  const HeaderData = [
    {
      key: "createdAt",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      dataIndex: "createdAt",
      width: 120,
      // fixed: "left",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.createdAt && text.createdAt}
        </p>
      ),
      sorter: (a, b) => a.createdAt.length - b.createdAt.length,
    },
    {
      key: "vendorName",
      title: (
        <p className="header-purchase-invoice font-semibold">Vendor Name</p>
      ),
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.vendorName && text.vendorName}
        </p>
      ),
      dataIndex: "vendorName",
      width: 150,
    },
    {
      key: "mobileNo",
      title: <p className="header-purchase-invoice font-semibold">Mobile</p>,
      dataIndex: "mobileNo",
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.mobileNo && text.mobileNo}
        </p>
      ),
      width: 120,
    },
    {
      key: "purchaseinvoiceNo",
      title: (
        <p className="header-purchase-invoice font-semibold">
          Sales Invoice No
        </p>
      ),
      render: (row, text) => (
        <p
          className="ml-1"
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
          }}
        >
          {text.purchaseinvoiceNo && text.purchaseinvoiceNo}
        </p>
      ),
      dataIndex: "purchaseinvoiceNo",
      width: 142,
    },
    {
      key: "totalAmount",
      title: (
        <p className="header-purchase-invoice font-semibold">Total Amount</p>
      ),
      render: (row, text) => (
        <p className="flex">
          <p>₹.</p>
          <p
            className="ml-1 mt-[0.15rem]"
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
          >
            {text.totalAmount && text.totalAmount.toLocaleString("en-IN")}
          </p>
        </p>
      ),
      dataIndex: "totalAmount",
      width: 150,
    },
    {
      key: "billStatus",
      title: (
        <p className="header-purchase-invoice font-semibold">Bill Status</p>
      ),
      dataIndex: "billStatus",
      width: 140,
    },
  ];

  //filters
  const [pageValue, setPageValue] = useState("");
  const [filteredValues, setFilteredValues] = useState("");
  const applyFilters = () => {
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var vendorId =
      !isEmpty(vendorList) || vendorList.length !== 0 ? vendorList : "";
    var billStatus =
      !isEmpty(billStatusList) || billStatusList.length !== 0
        ? billStatusList
        : "";

    let searchValue = {};
    searchValue.page = pageValue ? pageValue : 1;
    searchValue.limit = 10;
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (vendorId) {
      searchValue.vendorId = vendorId;
    }
    if (billStatus) {
      searchValue.billStatus = billStatus;
    }
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    setFilteredValues(searchValue);
    setTableLoading(true);
    dispatch(loadPurchaseSummaryReport(searchValue));
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [purchaseSummaryRows, setPurchaseSummaryRows] = useState([
    {
      key: "",
      balanceAmount: "",
      amountreceived: "",
      netTotalAmount: "",
      mobileNo: "",
      totalAmount: "",
      totalQty: "",
      createdAt: "",
      purchaseinvoiceNo: "",
      vendorName: "",
      _id: "",
    },
  ]);

  const purchaseSummaryDataTable =
    !isEmpty(purchase_summary_report) &&
    purchase_summary_report.invoices.length > 0
      ? purchase_summary_report.invoices.map((data, index) => {
          return {
            key: index + 1,
            _id: data._id,
            balanceAmount: data.balanceAmounttopay,
            amountreceived: data.amountreceived,
            netTotalAmount: data.netTotalAmount,
            mobileNo: data.vendorMobileNo,
            totalAmount: data.totalAmount,
            totalQty: data.totalQty,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            purchaseinvoiceNo: data.purchaseinvoiceNo,
            vendorName: data.vendorName,
            billStatus: (
              <Badge
                style={{
                  fontFamily: "Poppins",
                }}
                className={
                  data.billStatus &&
                  data.billStatus.length > 0 &&
                  data.billStatus[0].statusName === "paid"
                    ? "bg-[#edf6ef] font-semibold capitalize rounded-md text-[#49a563] p-2"
                    : data.billStatus &&
                      data.billStatus.length > 0 &&
                      data.billStatus[0].statusName === "partially paid"
                    ? "bg-[#f5f2e5] font-semibold capitalize rounded-md text-[#faad14] p-2"
                    : "bg-[#f1e7e9] font-semibold capitalize rounded-md text-[#d01717] p-2"
                }
              >
                {data.billStatus &&
                  data.billStatus.length > 0 &&
                  data.billStatus[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  console.log(purchaseSummaryDataTable, "purchaseSummaryDataTable");
  useEffect(() => {
    if (purchaseSummaryDataTable && purchaseSummaryDataTable.length > 0) {
      setPurchaseSummaryRows(purchaseSummaryDataTable);
    } else {
      setPurchaseSummaryRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchase_summary_report]);

  //paginations
  const handlePagination = (data) => {
    const filter = {
      page: data,
      limit: 10,
      organizationId: organizationId,
      vendorId: filteredValues ? filteredValues.vendorId : "",
      billStatus: filteredValues ? filteredValues.billStatus : "",
      fromDate: filteredValues ? filteredValues.fromDate : "",
      toDate: filteredValues ? filteredValues.toDate : "",
    };
    const searchFilterValues = Object.keys(filter).forEach(
      (data) => !filter[data] && delete filter[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    setPageValue(data);
    dispatch(loadPurchaseSummaryReport(filter));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = purchaseSummaryDataTable
      .filter((row) =>
        row.vendorName.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setPurchaseSummaryRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const handleDownloadPDF = () => {
    setDownloadLoading(true);
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var vendorId =
      !isEmpty(vendorList) || vendorList.length !== 0 ? vendorList : "";
    var billStatus =
      !isEmpty(billStatusList) || billStatusList.length !== 0
        ? billStatusList
        : "";

    let searchValue = {};
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (vendorId) {
      searchValue.vendorId = vendorId;
    }
    if (billStatus) {
      searchValue.billStatus = billStatus;
    }
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");

    api
      .post(`/org/getpurchasesummaryreport`, searchValue)
      .then((response) => {
        const stockReportExcel =
          !isEmpty(response) && response.data.invoices.length > 0
            ? response.data.invoices.map((data, index) => {
                return {
                  key: index + 1,
                  balanceAmount: data.balanceAmounttopay,
                  amountreceived: data.amountreceived,
                  netTotalAmount: data.netTotalAmount,
                  mobileNo: data.vendorMobileNo,
                  totalAmount: data.totalAmount,
                  totalQty: data.totalQty,
                  createdAt: data.createdAt
                    ? moment(data.createdAt).format("DD-MM-YYYY")
                    : "",
                  purchaseinvoiceNo: data.purchaseinvoiceNo,
                  vendorName: data.vendorName,
                  _id: data._id,
                  billStatus:
                    data.billStatus &&
                    data.billStatus.length > 0 &&
                    data.billStatus[0].statusName,
                };
              })
            : [];
        setTimeout(() => {
          let headerData = [
            "S.No, Date,Vendor Name,Mobile, Purchase Invoice No,Total Amount, Bill Status",
          ];

          let usersCsv = !isEmpty(stockReportExcel)
            ? stockReportExcel.reduce((acc, user) => {
                const {
                  key,
                  createdAt,
                  vendorName,
                  mobileNo,
                  purchaseinvoiceNo,
                  totalAmount,
                  billStatus,
                } = user;
                acc.push([
                  key,
                  createdAt,
                  vendorName,
                  mobileNo,
                  purchaseinvoiceNo,
                  totalAmount,
                  billStatus,
                ]);

                return acc;
              }, [])
            : false;

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "PurchaseSummaryReport.csv",
            fileType: "text/csv",
          });
          setDownloadLoading(false);
        }, 2500);
        return response.data;
      })
      .catch((error) => Promise.reject(error));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Purchase Summary Report | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Purchase Summary Report
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          (windowDimensions.height >= 700 && windowDimensions.height <= 767) ||
          (windowDimensions.height > 767 && windowDimensions.height < 830)
            ? "add-ledger-statment-reports-large-device"
            : windowDimensions.height > 830 && windowDimensions.height < 1000
            ? "add-ledger-statment-reports-extra-large-device"
            : windowDimensions.height > 1000
            ? "add-sales-summary-reports-extra-large-device"
            : "add-ledger-statment-reports"
        }
      >
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            (media === "md" ||
              media === "lg" ||
              media === "xl" ||
              media === "xxl") &&
            windowDimensions.height > 700
              ? "mt-2 pr-4 pl-4 pt-3 mb-4 bg-[#ffffff] h-[25%] rounded-md"
              : (media == "sm" || media == "xs") &&
                windowDimensions.height > 700
              ? "mt-2 pr-4 pl-4 pt-3 mb-4 h-[43%] pb-[20px] bg-[#ffffff] rounded-md"
              : "mt-2 pr-4 pl-4 pt-3 pb-2 mb-4 bg-[#ffffff] rounded-md"
          }
        >
          <Row
            className={
              windowDimensions.height > 700
                ? "pr-2 pl-2 pt-3 rounded-md"
                : "pr-2 pl-2 pt-3 pb-2 rounded-md"
            }
          >
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={vendorList}
                  onChange={(newValue) => setVendorList(newValue)}
                  placeholder="Select Vendor"
                  options={partyOptions}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={billStatusList}
                  onChange={(newValue) => setBillStatusList(newValue)}
                  placeholder="Select Bill Status"
                  options={
                    billStatusMetaData
                      ? billStatusMetaData.billStatusOptions
                      : []
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={fromDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[130%]"
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setFromDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select From Date"
                />
              )}
            </Col>
            <Col
              md={6}
              lg={6}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={toDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[130%]"
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setToDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select To Date"
                />
              )}
            </Col>
            <Col
              md={24}
              lg={24}
              sm={24}
              xs={24}
              className={
                media == "sm" || media == "xs"
                  ? "pr-2 w-[100%] mt-3"
                  : "pr-2 mt-3"
              }
            >
              <Row
                className={
                  media == "sm" || media == "xs" ? "flex" : "flex justify-end"
                }
              >
                {/* <Col
                  md={12}
                  lg={12}
                  sm={24}
                  xs={24}
                  className="pl-0 md:pl-10 lg:pl-10 xl:pl-10"
                > */}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      width:
                        media == "md"
                          ? "180px"
                          : media == "sm"
                          ? "300px"
                          : "250px",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    className={
                      media == "sm" || media == "xs" ? "flex w-[100%]" : "flex"
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setVendorList([]);
                        setBillStatusList([]);
                        setTableLoading(true);
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 2000);
                        dispatch(loadPurchaseSummaryReport(stockGetPayload));
                      }}
                      className={
                        media == "sm" || media == "xs"
                          ? "cursor-pointer ml-0 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                          : "cursor-pointer ml-5 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                      }
                    >
                      Reset
                    </div>
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => applyFilters()}
                      className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 bg-[#45bd4a] hover hover:bg-[green]"
                    >
                      Filter
                    </div>
                  </div>
                )}
                {/* </Col> */}
              </Row>
            </Col>
          </Row>
        </Col>
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 &&
            windowDimensions.height < 830 &&
            purchaseSummaryDataTable.length > 0
              ? "mt-[-2px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                purchaseSummaryDataTable.length > 0
              ? "mt-[-2px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                purchaseSummaryDataTable.length == 0
              ? "mt-[10px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 && windowDimensions.height < 1000
              ? "mt-[10px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000
              ? "mt-[10px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                purchaseSummaryDataTable.length == 0
              ? "mt-[10px] h-[100%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] h-[100%] rounded-md"
          }
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3 pb-5">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={18}
                  xs={18}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "180px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div className="w-[100%] lg:w-[65%] md:w-[65%]">
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search Vendor"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            fontSize: "11px",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={18} xs={18} className="pr-3">
                  <Row className="flex justify-end">
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "180px",
                            paddingRight: media == "md" ? "20px" : "14px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "20px" : "0px",
                            height: "35px",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={24}
                            xs={24}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                  "cursor-pointer border pt-[5px] pb-[5px] rounded-md border-1"
                              // : "cursor-pointer border pt-[5px] pb-[5px] sm:pl-[5px] md:pl-[10px] pl-[5px] lg:pl-[40px] xl:pl-[40px] xxl:pl-[40px] pr-[30px] rounded-md border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p
                                className={
                                  media == "sm" || media == "xs"
                                    ? "flex justify-center"
                                    : "flex justify-center"
                                }
                              >
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-4 pl-4 purchase-invoice-orders pb-12 pr-4"
                  : media === "md"
                  ? "mt-[-10px] pl-4 purchase-invoice-orders pb-12 pr-4"
                  : "pt-1 pl-4 purchase-invoice-orders pb-12 pr-4"
              }
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  purchaseSummaryRows &&
                  purchaseSummaryRows.length > 0 &&
                  !isEmpty(purchaseSummaryRows[0].vendorName)
                    ? purchaseSummaryRows
                    : []
                }
                rowClassName={"p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  // onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (e) => handlePagination(e),
                  // page
                  total: !isEmpty(search)
                    ? purchaseSummaryRows.length
                    : purchase_summary_report
                    ? purchase_summary_report.totalInvoices
                    : "",
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{
                  y: "100%",
                  x: purchaseSummaryDataTable.length > 0 ? 825 : "100%",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

PurchaseSummaryReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  vendorName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default PurchaseSummaryReport;
